export default __webpack_public_path__ + "static/media/Love06.a3938972.png";